@if (!isLoading) {
  <div class="page-container">
    <app-website-builders *staffCan="'Businesses.Membership.Manage'" [businessId]="businessId || ''"></app-website-builders>
    <header class="page-header">
      @if (business) {
         <div class="title-row">
        <h2>{{ business.name }}</h2>
        <!-- @if (businessDetails?.isActive===true) {
          <span class="status-badge" [class.ok]="businessDetails?.status === true" [class.warn]="businessDetails?.status !== true">Active</span>
        } @else {
          <span class="status-badge inactive">Inactive</span>
        } -->
      </div>
        <div class="subhead">
          <div class="id">ID: {{ business.businessId }}</div>
          @if (business.businessCategory) {<div class="category">Category : {{ business.businessCategory }}</div>}
          <div class="owner">
            Owner :
            @if (ownerUserId) {
              @if (canOpenUsers) {
                <a [routerLink]="['/users', ownerUserId]" [title]="ownerEmail || ''">{{ ownerName || ownerUserId }}</a>
              } @else {
                <span [title]="ownerEmail || ''">{{ ownerName || ownerUserId }}</span>
              }
            } @else {
              <span class="warn">none</span>
            }
          </div>
        </div>
      }
      <!-- View-only until Edit: only one admin can change a business at a time. -->
      <app-edit-lock-bar
        class="edit-lock"
        entityType="business"
        noun="business"
        [entityId]="businessId"
        (editingChange)="onEditingChange($event)">
      </app-edit-lock-bar>
    </header>

    <section class="panel grid two-col">
      <div class="card">
        <h3 class="card-title">Account</h3>
        <div class="kv">
          <!-- The owner is the account the business is billed under: their plan is the
               business's plan. Nobody owning it is a problem worth saying out loud. -->
          <div class="kv-row">
            <span class="k">Owner</span>
            <span class="v" [class.warn]="!ownerUserId">
              @if (ownerUserId) {
                @if (canOpenUsers) {
                  <a [routerLink]="['/users', ownerUserId]">{{ ownerName || ownerUserId }}</a>
                } @else {
                  {{ ownerName || ownerUserId }}
                }
                @if (ownerEmail) { <span class="muted"> · {{ ownerEmail }}</span> }
              } @else {
                No owner — assign an account holder from Users
              }
            </span>
          </div>
          <div class="kv-row"><span class="k">Phone</span><span class="v">{{ business?.phone || '—' }}</span></div>
          <div class="kv-row"><span class="k">Address</span><span class="v">{{ business?.address || '—' }}</span></div>
          <div class="kv-row">
            <span class="k">Payments</span>
            <span class="v"><a class="act-ghost act-sm" [routerLink]="['/payments', 'accounts']" [queryParams]="{ businessId: business?.businessId }">Payment accounts</a></span>
          </div>
        </div>
      </div>
      <div class="card">
        <h3 class="card-title">Features</h3>
        @if (subscriptionLoading) {
          <span class="muted">Loading features…</span>
        } @else if (subscription?.features?.length) {
          <div class="chip-list">
            @for (f of subscription!.features; track f.featureID) {
              <span class="chip" [class.light]="!f.isIncluded" [class.excluded]="!f.isIncluded"
                [title]="f.description || f.featureName">
                {{ f.isIncluded ? '✓' : '✕' }} {{ f.featureName }}
              </span>
            }
          </div>
        } @else {
          <span class="muted">No plan features</span>
        }
      </div>
    </section>

    <!-- Branches (specs/branches SCR-B9): family tree, structure history, detach while editing. -->
    <app-business-family-panel [businessId]="businessId" [editing]="editing"></app-business-family-panel>

    <!-- Access (specs/maintenance): under maintenance or open, and the buttons to change it while editing. -->
    <app-business-maintenance-panel [businessId]="businessId" [businessName]="business?.name || null" [editing]="editing"></app-business-maintenance-panel>

    <!-- What this business's customers see on the till's second screen. Read-only. -->
    <app-customer-display-panel [businessId]="businessId" [businessTypeName]="businessDetails?.businessType ?? null"></app-customer-display-panel>

    <div class="panel grid two-col">
      <section class="col-panel">
        <div class="section-header">
          <h3>Subscription</h3>
          @if (subscriptionStatus; as status) {
            <span class="status-badge" [class.ok]="status.active" [class.inactive]="!status.active"
              [title]="subscription?.status && subscription?.status !== status.label ? 'Reported status: ' + subscription?.status : ''">
              {{ status.label }}
            </span>
          }
        </div>

        @if (subscriptionLoading) {
          <span class="muted">Loading subscription…</span>
        } @else if (subscriptionError) {
          <span class="muted">{{ subscriptionError }}</span>
        } @else if (subscription) {
          <!-- Summary first: what plan, what it costs, and when it next changes. -->
          <div class="sub-summary">
            <div class="sub-plan">{{ subscription.planName || 'No plan' }}</div>
            <div class="sub-line">
              @if (subscription.planPrice) {
                {{ subscription.currency }} {{ subscription.planPrice | number:'1.2-2' }}@if (subscription.billingInterval) {&nbsp;/&nbsp;{{ subscription.billingInterval }}}
                <!-- No bound pricing row (Free / trial / admin-assigned): the plan's current
                     list price, not what the customer is charged. -->
                @if (subscription.isIndicativePrice) { <span class="muted">(list price, not billed)</span> }
              } @else {
                No charge
              }
              @if (subscriptionTimelineLabel) { <span class="sub-dot">·</span> {{ subscriptionTimelineLabel }} }
            </div>
          </div>

          <!-- Over-limit accounts are the thing support most needs to notice. -->
          @for (warning of subscriptionLimitWarnings; track warning) {
            <div class="sub-warning" role="status">{{ warning }}</div>
          }

          <div class="kv">
            @if (subscription.startDate) {
              <div class="kv-row">
                <span class="k">Member since</span>
                <span class="v">{{ subscription.startDate | date:'mediumDate' }}</span>
              </div>
            }
            <div class="kv-row">
              <span class="k">Businesses</span>
              <span class="v" [class.over]="isOverLimit(subscription.currentBusinesses, subscription.maxBusinesses)">
                {{ subscription.currentBusinesses }}{{ subscription.maxBusinesses != null ? ' of ' + subscription.maxBusinesses : '' }}
              </span>
            </div>
            <div class="kv-row">
              <!-- Plan limits are per account, so count the account's terminals, not this business's. -->
              <span class="k">Terminals <span class="muted">(account)</span></span>
              <span class="v" [class.over]="isOverLimit(subscription.currentTerminals, subscription.maxTerminals)">
                {{ subscription.currentTerminals }}{{ subscription.maxTerminals != null ? ' of ' + subscription.maxTerminals : '' }}
              </span>
            </div>
          </div>

          <!-- Billing profile of the account holder this business is billed under. Collapsed by
               default: support needs it for billing questions, not on every visit. -->
          <div class="sub-billing">
            <div class="sub-billing-row">
              <span><span class="k">Billed to</span> {{ subscription.hasBillingProfile ? (billingContactName || '—') : 'No billing profile' }}</span>
              @if (subscription.hasBillingProfile) {
                <button type="button" class="btn-link" (click)="showBillingDetails = !showBillingDetails"
                        [attr.aria-expanded]="showBillingDetails">
                  {{ showBillingDetails ? 'Hide details' : 'Details' }}
                </button>
              }
            </div>
            @if (showBillingDetails && subscription.hasBillingProfile) {
              <div class="kv sub-billing-details">
                <div class="kv-row"><span class="k">Invoice email</span><span class="v">{{ subscription.billingInvoiceEmail || '—' }}</span></div>
                <div class="kv-row"><span class="k">Phone</span><span class="v">{{ subscription.billingPhone || '—' }}</span></div>
                <div class="kv-row"><span class="k">Address</span><span class="v">{{ billingAddressLine || '—' }}</span></div>
                <div class="kv-row"><span class="k">Tax ID</span><span class="v">{{ subscription.billingTaxId || '—' }}</span></div>
                <div class="kv-row"><span class="k">Time zone</span><span class="v">{{ subscription.billingTimeZone || '—' }}</span></div>
                @if (subscription.pricingCountryName) {
                  <div class="kv-row"><span class="k">Priced for</span><span class="v">{{ subscription.pricingCountryName }}</span></div>
                }
              </div>
            }
          </div>
        } @else if (!ownerUserId) {
          <!-- Nothing to resolve: the plan is the owner's, and there is no owner. -->
          <span class="muted">No owner, so no plan. A business is billed under its owner's plan; assign an owner (an account holder) from Users first.</span>
        } @else {
          <span class="muted">No subscription for this business</span>
        }

        <!-- Modules, operating mode and plan assignment all change the business: edit mode only. -->
       <fieldset class="edit-scope" [disabled]="!editing">
        <!-- Modules: add-on plans held beside the owner's main plan (Inventory, Website, ...).
             Comping one here does not touch the main plan; cancelling one here is local only. -->
        <div class="assign-plan mode-block">
          <h4 class="mode-title">Modules</h4>
          @if (addOnMessage) { <div class="assign-note ok">{{ addOnMessage }}</div> }
          @if (addOnsError) { <div class="assign-note err">{{ addOnsError }}</div> }

          @if (addOnsLoading) {
            <span class="muted">Loading modules…</span>
          } @else if (!liveAddOns.length) {
            <span class="muted">No modules on this account</span>
          } @else {
            <div class="kv">
              @for (addOn of liveAddOns; track addOn.userPlanAddOnId) {
                <div class="kv-row">
                  <span class="k">{{ moduleName(addOn.planId, addOn.planName) }}</span>
                  <span class="v">
                    <span class="pill pill-sm" [class.pill-purple]="addOn.isGranted" [class.pill-green]="!addOn.isGranted"
                          [title]="addOn.isGranted ? 'Granted by an admin; nothing is billed' : 'Bought through checkout'">
                      {{ moduleSource(addOn) }}
                    </span>
                    @if (addOn.isGranted) {
                      {{ addOn.endDate ? 'until ' + (addOn.endDate | date:'mediumDate') : 'until cancelled' }}
                    } @else {
                      {{ addOn.autoRenewal ? 'renews' : 'ends' }} {{ addOn.endDate ? (addOn.endDate | date:'mediumDate') : '—' }}
                    }
                    @if (canManagePlans) {
                      <ng-container *staffCan="'Businesses.Entitlements.Manage'"><button type="button" class="btn-link" (click)="cancelAddOn(addOn)"
                              [disabled]="addOnBusyId === addOn.userPlanAddOnId">
                        {{ addOnBusyId === addOn.userPlanAddOnId ? 'Cancelling…' : 'Cancel' }}
                      </button></ng-container>
                    }
                  </span>
                </div>
              }
            </div>
          }

          @if (canManagePlans && grantableAddOnPlans.length) {
            <div class="mode-row">
              <select class="input" [(ngModel)]="grantAddOnPlanId" [ngModelOptions]="{ standalone: true }" aria-label="Module to comp">
                <option [ngValue]="null">Comp a module…</option>
                @for (p of grantableAddOnPlans; track p.planId) {
                  <option [ngValue]="p.planId">{{ p.label }}</option>
                }
              </select>
              <input class="input" type="date" [(ngModel)]="grantAddOnEndsAt" [ngModelOptions]="{ standalone: true }"
                     aria-label="Comp ends on" title="Leave empty for until cancelled" />
              <ng-container *staffCan="'Businesses.Entitlements.Manage'"><button type="button" class="btn primary" (click)="grantAddOn()" [disabled]="addOnSaving || !grantAddOnPlanId">
                {{ addOnSaving ? 'Granting…' : 'Grant' }}
              </button></ng-container>
            </div>
            <p class="muted mode-note">Comp: local only, nothing is billed. Leave the date empty for until cancelled.
              Multi-Location comes with Connect, so it is changed on the main plan, not here.</p>
          }
        </div>

        <!-- Operating mode requires Businesses.Operate: it rewrites the landing
             destination and the checkout steps for every register in the
             business, so the merchant's own settings show it read-only and
             point here. -->
        @if (staffAuth.can('Businesses.Operate')) {
          <div class="assign-plan mode-block">
            <h4 class="mode-title">Operating mode</h4>
            <p class="muted mode-note">
              Changes how the register behaves for everyone using it. Set at creation
              by the setup wizard; change it here only on request.
            </p>

            @if (modeMessage) { <div class="assign-note ok">{{ modeMessage }}</div> }
            @if (modeError) { <div class="assign-note error">{{ modeError }}</div> }

            <div class="mode-row">
              <select class="input" [(ngModel)]="selectedModeId" [ngModelOptions]="{ standalone: true }"
                      aria-label="Operating mode">
                <option [ngValue]="null">Derive from business type</option>
                @for (mode of modes; track mode.businessModeId) {
                  <option [ngValue]="mode.businessModeId">{{ mode.name }}</option>
                }
              </select>
              <ng-container *staffCan="'Businesses.Operate'"><button type="button" class="btn primary" (click)="saveBusinessMode()" [disabled]="modeSaving">
                {{ modeSaving ? 'Applying…' : 'Apply mode' }}
              </button></ng-container>
            </div>
          </div>
        }

        @if (canManagePlans) {
          <div class="assign-plan">
            @if (assignMessage) { <div class="assign-note ok">{{ assignMessage }}</div> }

            @if (!ownerUserId) {
              <!-- Plans are held by the owner's account; with nobody to hold it the API refuses. -->
              <div class="assign-note err">A plan or trial is held by the business's owner, and this business has none. Assign an owner from Users first.</div>
            } @else if (!showAssignPlan) {
              <div class="assign-cta">
                <ng-container *staffCan="'Businesses.Entitlements.Manage'"><button type="button" class="btn primary" (click)="startTrial()">🎁 Start Free Trial</button></ng-container>
                <ng-container *staffCan="'Businesses.Entitlements.Manage'"><button type="button" class="btn-link" (click)="startAssignPlan()">Assign paid plan</button></ng-container>
              </div>
            } @else {
              <ng-container *staffCan="'Businesses.Entitlements.Manage'"><form class="assign-form" [formGroup]="assignForm" (ngSubmit)="submitAssignPlan()">
                <div class="assign-title">{{ isTrialMode ? 'Start a free trial' : 'Assign a paid plan' }}</div>
                @if (assignError) { <div class="assign-note err">{{ assignError }}</div> }

                <label class="assign-field">
                  <span>Plan</span>
                  <select formControlName="planId">
                    <option [ngValue]="null" disabled>Choose a plan…</option>
                    @for (p of plans; track p.planID) {
                      <option [ngValue]="p.planID">{{ p.planName }}</option>
                    }
                  </select>
                </label>

                <label class="assign-field">
                  <span>Country</span>
                  <select formControlName="countryCode">
                    <option [ngValue]="null">— Select country —</option>
                    @for (c of countries; track c.countryId) {
                      <option [ngValue]="c.countryISO || c.countryCode">{{ c.countryName }}</option>
                    }
                  </select>
                  <small class="muted">Sets the payment provider automatically (Paystack in West Africa, Stripe in US/Europe).</small>
                </label>

                @if (isTrialMode) {
                  <label class="assign-field">
                    <span>Trial length</span>
                    <select formControlName="trialLengthDays">
                      <option [ngValue]="7">7 days</option>
                      <option [ngValue]="14">14 days</option>
                      <option [ngValue]="30">30 days</option>
                      <option [ngValue]="0">Custom date…</option>
                    </select>
                  </label>

                  @if (assignForm.get('trialLengthDays')?.value === 0) {
                    <label class="assign-field">
                      <span>Trial ends on</span>
                      <input type="date" formControlName="customTrialEndsAt" />
                    </label>
                  }

                  <label class="assign-field checkbox">
                    <input type="checkbox" formControlName="autoBill" />
                    <span>Automatically bill the customer when the trial ends</span>
                  </label>
                } @else {
                  <label class="assign-field">
                    <span>Billing cycle</span>
                    <select formControlName="billingCycle">
                      <option value="Monthly">Monthly</option>
                      <option value="Yearly">Yearly</option>
                    </select>
                  </label>
                }

                <div class="assign-actions">
                  <button type="button" class="btn secondary" (click)="cancelAssignPlan()" [disabled]="assignSaving">Cancel</button>
                  <button type="submit" class="btn primary" [disabled]="assignSaving">
                    {{ assignSaving ? 'Saving…' : (isTrialMode ? 'Start Trial' : 'Assign Plan') }}
                  </button>
                </div>
              </form></ng-container>
            }
          </div>
        }
       </fieldset>
      </section>

      <section class="col-panel">
       <fieldset class="edit-scope" [disabled]="!editing">
        <div class="section-header">
          <h3>Terminals</h3>
          <span class="count-badge">{{ terminals.length }}</span>
          @if (canManageTerminals && !showAddTerminal) {
            <ng-container *staffCan="'Businesses.Operate'"><button type="button" class="add-terminal-btn" (click)="startAddTerminal()">+ Add terminal</button></ng-container>
          }
        </div>

        @if (showAddTerminal) {
          <div class="add-terminal-form">
            <input type="text" [formControl]="terminalNameControl" placeholder="Terminal name (optional)"
              maxlength="20" [disabled]="savingTerminal" />
            <ng-container *staffCan="'Businesses.Operate'"><button type="button" (click)="saveTerminal()" [disabled]="savingTerminal">
              {{ savingTerminal ? 'Adding…' : 'Add terminal' }}
            </button></ng-container>
            <button type="button" class="secondary" (click)="cancelAddTerminal()" [disabled]="savingTerminal">
              Cancel
            </button>
          </div>
          @if (terminalCreateError) {
            <div class="form-error">{{ terminalCreateError }}</div>
          }
        }

        @if (terminalsLoading) {
          <span class="muted">Loading terminals…</span>
        } @else if (terminalsError) {
          <span class="muted">{{ terminalsError }}</span>
        } @else if (terminals.length > 0) {
          @if (terminalStatusError) {
            <div class="form-error">{{ terminalStatusError }}</div>
          }
          <ul class="list">
            @for (t of terminals; track t.terminalId) {
              <li class="list-item terminal-row">
                <div class="terminal-info">
                  <div class="primary">{{ t.terminalName || ('Terminal ' + t.terminalNo) }}</div>
                  <!-- No "never" case here: the status pill below already says so. -->
                  <div class="secondary">
                    #{{ t.terminalNo }}@if (t.lastSeenUtc) { · last seen {{ t.lastSeenUtc | date: 'short' }} }
                  </div>
                  <div class="terminal-flags">
                    <span [class]="terminalStatusClass(t)">{{ terminalStatusLabel(t) }}</span>
                    @if (t.offlineMode) {
                      <span class="pill pill-sm pill-amber"
                        [title]="'Switched on ' + (t.offlineModeChangedUtc | date: 'short')">Offline mode</span>
                    }
                    @if (!t.isActive) {
                      <span class="pill pill-sm pill-grey">Disabled</span>
                    }
                  </div>
                </div>
                @if (canManageTerminals) {
                  <ng-container *staffCan="'Businesses.Operate'"><button type="button" class="terminal-toggle-btn"
                    [class.enable]="!t.isActive"
                    [disabled]="togglingTerminalId === t.terminalId"
                    (click)="setTerminalActive(t, !t.isActive)">
                    {{ togglingTerminalId === t.terminalId
                        ? '…'
                        : (t.isActive ? 'Disable' : 'Enable') }}
                  </button></ng-container>
                }
              </li>
            }
          </ul>
        } @else {
          <span class="muted">No terminals for this business</span>
        }
       </fieldset>
      </section>
    </div>

    <!-- Agents, Plus Intelligence and Micro apps for this business (specs/agents spec-v1.7): its own setting wins over the platform switch. -->
    <ng-container *staffCan="'Platform.Ai.Switches'">
      <app-business-features-panel [businessId]="businessId"></app-business-features-panel>
    </ng-container>

    <!-- Plus Intelligence (specs/agents v1.2): billing mode and the month's usage, read-only — set on the AI API, shown here. -->
    <app-business-intelligence-panel [businessId]="businessId"></app-business-intelligence-panel>

    <!-- Websites (specs/agents v1.5 FR-55.8): each website's build mode, who set it and when — chosen by the owner in the builder, shown here. -->
    <app-business-websites-panel [businessId]="businessId"></app-business-websites-panel>

    <!-- AI images (specs/agents CONTRACT-v1.4 §9): the add-on, this month's allowance and cost, each request — read-only. -->
    <app-business-ai-images-panel [businessId]="businessId" [addOns]="addOns" [addOnPlans]="addOnPlans" [users]="businessUsers"></app-business-ai-images-panel>

    @if (canViewFees) {
      <section class="panel">
        <div class="section-header">
          <h3>Marketplace Fees</h3>
        </div>

        @if (feeIsLoading) {
          <span class="muted">Loading fee configuration…</span>
        } @else {
          <ng-container *staffCan="'Businesses.Entitlements.Manage'"><form [formGroup]="feeForm" (ngSubmit)="saveFeeConfig()" class="fee-form">
           <fieldset class="edit-scope" [disabled]="!editing">
            @if (!canManageFees) {
              <div class="form-info">View only: only super admin can create or update fees.</div>
            }
            <div class="fee-grid">
              <label class="field">
                <span>Seller commission rate (%)</span>
                <!-- Not charged: the marketplace commission is the seller's fee plan or the custom rate set
                     when their marketplace application was approved (fulfilment F0.4). Kept read-only so
                     nobody edits a number that changes nothing. -->
                <input type="number" step="0.01" min="0" formControlName="sellerCommissionRatePct" readonly
                       title="Not used. The commission charged is the seller's marketplace fee plan or custom rate." />
                <span class="muted">Not used for charging. Commission comes from the seller's marketplace fee plan or custom rate.</span>
              </label>
              <label class="field">
                <span>Customer fee rate (%)</span>
                <input type="number" step="0.01" min="0" formControlName="customerFeeRatePct" />
              </label>
              <label class="field">
                <span>Seller commission min amount</span>
                <input type="number" step="0.01" min="0" formControlName="sellerCommissionMinAmount" />
              </label>
              <label class="field">
                <span>Seller commission max amount</span>
                <input type="number" step="0.01" min="0" formControlName="sellerCommissionMaxAmount" />
              </label>
              <label class="field">
                <span>Customer fee min amount</span>
                <input type="number" step="0.01" min="0" formControlName="customerFeeMinAmount" />
              </label>
              <label class="field">
                <span>Customer fee max amount</span>
                <input type="number" step="0.01" min="0" formControlName="customerFeeMaxAmount" />
              </label>
              <label class="field">
                <span>Effective from</span>
                <input type="date" formControlName="effectiveFrom" />
              </label>
              <label class="field">
                <span>Effective to</span>
                <input type="date" formControlName="effectiveTo" />
              </label>
            </div>

            @if (feeForm.errors?.['sellerRangeInvalid']) {
              <div class="form-error">Seller commission min amount must be less than or equal to max amount.</div>
            }
            @if (feeForm.errors?.['customerRangeInvalid']) {
              <div class="form-error">Customer fee min amount must be less than or equal to max amount.</div>
            }
            @if (feeForm.errors?.['effectiveDateInvalid']) {
              <div class="form-error">Effective to date must be the same as or after effective from date.</div>
            }
            @if (feeError) {
              <div class="form-error">{{ feeError }}</div>
            }
            @if (feeSaveMessage) {
              <div class="form-success">{{ feeSaveMessage }}</div>
            }

            @if (canManageFees) {
              <div class="form-actions">
                <button type="submit" [disabled]="feeForm.invalid || feeIsSaving">
                  {{ feeConfig ? 'Update Fees' : 'Add Fees' }}
                </button>
              </div>
            }
           </fieldset>
          </form></ng-container>
        }
      </section>
    }


    <section class="panel">
      <div class="section-header">
        <h3>Delivery Options</h3>
      </div>

      @if (deliveryIsLoading) {
        <span class="muted">Loading delivery configuration…</span>
      } @else if (deliveryConfig) {
       <fieldset class="edit-scope" [disabled]="!editing">
        <p class="muted">
          Switch on what this seller offers, set what they charge, and define the windows buyers
          can choose. Windows are read in the seller's time zone.
        </p>

        <div class="form-grid">
          <label class="field">
            <span>Time zone</span>
            <select [(ngModel)]="deliveryConfig.timezone" name="deliveryTimezone">
              <option [ngValue]="null">Not set</option>
              @for (tz of timezones; track tz) {
                <option [ngValue]="tz">{{ tz }}</option>
              }
            </select>
          </label>
        </div>

        <ul class="list">
          @for (option of deliveryConfig.options; track option.deliveryTypeId) {
            <li class="list-item">
              <div class="primary">
                <label class="delivery-toggle">
                  <input type="checkbox" [(ngModel)]="option.isActive"
                         [name]="'deliveryActive_' + option.deliveryTypeId" />
                  <span>{{ option.name }}</span>
                </label>
              </div>
              @if (option.description) {
                <div class="secondary">{{ option.description }}</div>
              }

              @if (option.isActive) {
                <div class="form-grid delivery-option-body">
                  <label class="field">
                    <span>Price</span>
                    <input type="number" step="0.01" min="0" [(ngModel)]="option.price"
                           [name]="'deliveryPrice_' + option.deliveryTypeId" placeholder="0.00" />
                  </label>
                </div>

                <div class="delivery-slots">
                  <span class="delivery-slots-title">Time windows</span>

                  @if (option.timeSlots.length) {
                    <div class="delivery-slot-chips">
                      @for (slot of option.timeSlots; track $index) {
                        <span class="delivery-slot-chip">
                          <strong>{{ formatDayName(slot.dayOfWeek) }}</strong>
                          {{ formatTime(slot.startTime) }} – {{ formatTime(slot.endTime) }}
                          @if (slot.maxOrders) {
                            <em>(max {{ slot.maxOrders }})</em>
                          }
                          <ng-container *staffCan="'Businesses.Operate'"><button type="button" class="delivery-slot-remove"
                                  (click)="removeTimeSlot(option, $index)"
                                  aria-label="Remove window">×</button></ng-container>
                        </span>
                      }
                    </div>
                  } @else {
                    <span class="muted">No windows configured — buyers see no availability time for this option.</span>
                  }

                  <div class="delivery-slot-add">
                    <select [(ngModel)]="newSlotDay[option.deliveryTypeId]"
                            [name]="'slotDay_' + option.deliveryTypeId">
                      <option value="">Day</option>
                      @for (day of DAY_NAMES; track day; let i = $index) {
                        <option [ngValue]="i">{{ day }}</option>
                      }
                    </select>
                    <input type="time" [(ngModel)]="newSlotStart[option.deliveryTypeId]"
                           [name]="'slotStart_' + option.deliveryTypeId" />
                    <input type="time" [(ngModel)]="newSlotEnd[option.deliveryTypeId]"
                           [name]="'slotEnd_' + option.deliveryTypeId" />
                    <input type="number" min="1" placeholder="Max orders"
                           [(ngModel)]="newSlotMaxOrders[option.deliveryTypeId]"
                           [name]="'slotMax_' + option.deliveryTypeId" />
                    <ng-container *staffCan="'Businesses.Operate'"><button type="button" (click)="addTimeSlot(option)">Add window</button></ng-container>
                  </div>
                </div>
              }
            </li>
          }
        </ul>

        @if (deliveryError) {
          <div class="form-error">{{ deliveryError }}</div>
        }
        @if (deliverySaveMessage) {
          <div class="form-success">{{ deliverySaveMessage }}</div>
        }

        <div class="form-actions">
          <ng-container *staffCan="'Businesses.Operate'"><button type="button" (click)="saveDeliveryConfig()" [disabled]="deliveryIsSaving">
            {{ deliveryIsSaving ? 'Saving…' : 'Save Delivery Options' }}
          </button></ng-container>
        </div>
       </fieldset>
      } @else {
        <span class="muted">{{ deliveryError || 'No delivery configuration for this business' }}</span>
      }
    </section>

    <section class="panel">
      <div class="section-header">
        <h3>Pending Business Changes</h3>
      </div>
      <app-pending-seller-changes [businessId]="businessId" [readOnly]="!editing"></app-pending-seller-changes>
    </section>

    <section class="panel">
      <div class="section-header">
        <h3>Users Assigned</h3>
        <span class="count-badge">{{ businessUsers.length }}</span>
      </div>
      @if (businessUsers.length > 0) {
        <ul class="list">
          @for (u of businessUsers; track u.userId) {
            <li class="list-item user-row">
              <div>
                <div class="primary">{{ u.firstName }} {{ u.lastName }}</div>
                <div class="secondary">{{ u.email }}</div>
              </div>
              <a class="act-ghost act-sm" [routerLink]="['/profile', u.userId]">View profile</a>
            </li>
          }
        </ul>
      } @else {
        <span class="muted">No users assigned to this business</span>
      }
    </section>

    <section class="panel">
      <div class="section-header">
        <h3>Business Roles</h3>
        <span class="count-badge">{{ businessRoles.length }}</span>
      </div>
      @if (businessRoles.length > 0) {
        <div class="chip-list">
          @for (role of businessRoles; track role.roleId) {
            <span class="chip">{{ role.displayName || role.roleName }}</span>
          }
        </div>
      } @else {
        <span class="muted">No business roles</span>
      }
    </section>

    <section class="panel">
      <div class="section-header">
        <h3>Business Permissions</h3>
        <span class="count-badge">{{ businessPermissions.length }}</span>
      </div>
      @if (businessPermissions.length > 0) {
        <div class="chip-list">
          @for (p of businessPermissions; track p.code) {
            <span class="chip light">{{ p.code }}</span>
          }
        </div>
      } @else {
        <span class="muted">No business permissions</span>
      }
    </section>
  </div>
} @else {
  <div class="page-loading">
    <p>Loading business…</p>
  </div>
}
